import { BlogsSubmenu, PageBreadcrumbProps, PageContent, getBlogsBreadcrumbs } from '../..';
import BlogArticlesList from './BlogArticlesList';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function BlogArticlesPage() {
  const [breadcrumbs, setBreadcrumbs] = useState<PageBreadcrumbProps>();
  const location = useLocation();
  const title = "Blogs: Articles"

  /**
   * Initialize breadcrumbs for the page depending on the route
   */
  useEffect(() => {
      const newBreadcrumbs:PageBreadcrumbProps = getBlogsBreadcrumbs(location.pathname);
      setBreadcrumbs(newBreadcrumbs);
    },[location.pathname]
  );

  return (
    <PageContent
      title={title}
      breadcrumbs={breadcrumbs}
      submenu={<BlogsSubmenu />}
    >
      <BlogArticlesList />
    </PageContent>
  );
}

export default BlogArticlesPage
